import { createContext, useContext, useEffect, useRef, useState } from 'react';
import { useERSContext } from '../sdk';

const MapContext = createContext();
export const useMapContext = () => useContext(MapContext);

export const MapContextProvider = ({ children }) => {
  const { postMessageToPopMapWindow } = useERSContext();
  const mapRef = useRef(null);
  const mapDrawRef = useRef(null);
  const mapMarkersRef = useRef({
    user: new Map(),
    incident: new Map(),
    assignResponder: new Map(),
    poi: new Map(),
    editingPoi: new Map(),
    geofence: new Map(),
    camera: new Map(),
  });
  const mapLinesRef = useRef({
    incidentAssignee: new Map(),
    editingIncidentAssignee: new Map(),
    geofence: new Map(),
  });

  const [isMapHidden, setIsMapHidden] = useState(false);
  const [selectedIncident, setSelectedIncident] = useState(null);
  const [editingIncidentAndCandidates, setEditingIncidentAndCandidates] = useState(null);

  // this should be an array as 1 incident can have multiple responders
  const [selectedResponder, setSelectedResponder] = useState(null);
  const [respondersForCreateIncident, setRespondersForCreateIncident] = useState([]);
  const [isMapLoaded, setIsMapLoaded] = useState(false);

  const [createIncidentMarker, setCreateIncidentMarker] = useState({
    coord: null,
    isDraggable: false,
  });

  const mapControlRef = useRef(null);
  const registerMapControl = controls => {
    mapControlRef.current = controls;
  };

  // control state
  const focusIncident = incident => {
    postMessageToPopMapWindow({ type: 'focusIncident', payload: incident });
    setSelectedIncident(incident);
  };
  const unFocusIncident = () => {
    postMessageToPopMapWindow({ type: 'unFocusIncident', payload: null });
    setSelectedIncident(null);
  };

  const focusResponder = responder => {
    postMessageToPopMapWindow({ type: 'focusResponder', payload: responder });
    setSelectedResponder(responder);
  };
  const unFocusResponder = () => {
    postMessageToPopMapWindow({ type: 'unFocusResponder', payload: null });
    setSelectedResponder(null);
  };

  // create incident flow
  const plotDraggableIncidentMarker = coord => {
    unFocusIncident();
    setSelectedResponder(null);
    setCreateIncidentMarker({ coord: coord, isDraggable: true });
    postMessageToPopMapWindow({ type: 'plotDraggableIncidentMarker', payload: coord });
  };
  // for updating the draggable marker
  const updateDraggableIncidentMarker = coord => {
    setCreateIncidentMarker(prev => (prev ? { ...prev, coord } : { coord }));
    postMessageToPopMapWindow({ type: 'updateDraggableIncidentMarker', payload: coord });
  };
  // end incident flow
  const endCreateIncidentFlow = () => {
    setCreateIncidentMarker({ coord: null, isDraggable: false });
    postMessageToPopMapWindow({ type: 'endCreateIncidentFlow', payload: null });
  };

  useEffect(() => {
    postMessageToPopMapWindow({ type: 'selectedResponder', payload: selectedResponder });
  }, [selectedResponder]);

  useEffect(() => {
    postMessageToPopMapWindow({ type: 'editingIncidentAndCandidates', payload: editingIncidentAndCandidates });
  }, [editingIncidentAndCandidates]);

  useEffect(() => {
    postMessageToPopMapWindow({ type: 'respondersForCreateIncident', payload: respondersForCreateIncident });
  }, [respondersForCreateIncident]);

  return (
    <MapContext.Provider
      value={{
        mapRef,
        mapDrawRef,
        mapMarkersRef,
        mapLinesRef,
        isMapHidden,
        setIsMapHidden,
        selectedIncident,
        setSelectedIncident,
        editingIncidentAndCandidates,
        setEditingIncidentAndCandidates,
        selectedResponder,
        setSelectedResponder,
        createIncidentMarker,
        focusIncident,
        unFocusIncident,
        focusResponder,
        unFocusResponder,
        plotDraggableIncidentMarker,
        updateDraggableIncidentMarker,
        endCreateIncidentFlow,
        mapControlRef,
        registerMapControl,
        respondersForCreateIncident,
        setRespondersForCreateIncident,
        setIsMapLoaded,
        isMapLoaded,
      }}
    >
      {children}
    </MapContext.Provider>
  );
};
